import { useMemo } from 'react'
import useAppStore from '$appStore'
import { CompanySettings } from '$models'
import { constructActiveCompanySettings } from '$utils'

export function useCompanySettings(): CompanySettings {
  const activeCompany = useAppStore((state) => state.activeCompany)

  // Use useMemo with empty dependency array to calculate only once
  const companySettings = useMemo(() => {
    if (!activeCompany) return {} as CompanySettings

    const settings = constructActiveCompanySettings(activeCompany)

    return {
      address: activeCompany.address,
      name: activeCompany.name,
      tier: activeCompany.tier,
      pos: activeCompany.pos,
      invoiceEmail: activeCompany.invoiceEmail,
      countryPreference: settings.countryPreference,
      weekStartPreference: settings.weekStartPreference,
      dayStartPreference: settings.dayStartPreference,
      localePreference: settings.localePreference,
      timeZonePreference: settings.timeZonePreference,
      provincePreference: settings.provincePreference,
      payrollSystemPreference: settings.payrollSystemPreference,
      hasPayrollPermission: settings.hasPayrollPermission,
      hasManagerPermission: settings.hasManagerPermission,
      hasTimePermission: settings.hasTimePermission,
      hasSalaryPermission: settings.hasSalaryPermission,
      hasStockPermission: settings.hasStockPermission,
      defaultFreightTaxRatePreference: settings.defaultFreightTaxRatePreference,
      overrideSalesTaxRatePreference: settings.overrideSalesTaxRatePreference,
      includePosClockinsPreference: settings.includePosClockinsPreference,
      timeAllowsPaySummaryPreference: settings.timeAllowsPaySummaryPreference,
      clockinRoundingPreference: settings.clockinRoundingPreference,
      timeRosterPublicTokenPreference: settings.timeRosterPublicTokenPreference,
      xeroFreightAccountPreference: settings.xeroFreightAccountPreference,
      teamAppEnabled: settings.teamAppEnabled,
      teamAppDisplayPayInformation: settings.teamAppDisplayPayInformation,
      teamAppDisplayPhoneNumbers: settings.teamAppDisplayPhoneNumbers,
    }
  }, [activeCompany])

  return companySettings
}
